import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { PublicationService } from '../../../publication.service';
import { FixErrorPublicationsDto } from '@models/publications/fix-error-publications-dto';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface FixErrorsModalData {
  storeCode: string;
}

export interface ErrorCountRow {
  errorCode: string;
  count: number;
}

@Component({
  selector: 'app-fix-errors-modal',
  templateUrl: './fix-errors-modal.component.html',
  styleUrls: ['./fix-errors-modal.component.scss'],
})
export class FixErrorsModalComponent implements OnInit {
  storeCode: string;
  errorsReport: ErrorCountRow[] = [];
  selectedErrorCode: string | null = null;
  operations: string[] = [];
  selectedOperation: string | null = null;
  loadingErrors = false;
  loadingOperations = false;
  submitting = false;
  displayedColumns = ['errorCode', 'count'];

  constructor(
    public dialogRef: MatDialogRef<FixErrorsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FixErrorsModalData,
    private publicationService: PublicationService,
    private snackBar: MatSnackBar
  ) {
    this.storeCode = data.storeCode;
  }

  ngOnInit() {
    this.loadErrorsReport();
  }

  loadErrorsReport() {
    this.loadingErrors = true;
    this.publicationService.getErrorsReport(this.storeCode).subscribe({
      next: (report) => {
        this.errorsReport = (report || []).map((pair) => ({ errorCode: pair.first, count: pair.second }));
        this.loadingErrors = false;
      },
      error: () => {
        this.loadingErrors = false;
        this.snackBar.open('Failed to load errors report.', 'CLOSE', { duration: 3000 });
      },
    });
  }

  loadOperations() {
    this.loadingOperations = true;
    this.publicationService.getFixErrorAllowedOperations().subscribe({
      next: (ops) => {
        this.operations = ops || [];
        this.loadingOperations = false;
      },
      error: () => {
        this.loadingOperations = false;
        this.snackBar.open('Failed to load operations.', 'CLOSE', { duration: 3000 });
      },
    });
  }

  selectError(row: ErrorCountRow) {
    this.selectedErrorCode = row.errorCode;
  }

  selectOperation(operation: string) {
    this.selectedOperation = operation;
  }

  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  goForward(stepper: MatStepper) {
    if (stepper.selectedIndex === 0 && this.operations.length === 0) {
      this.loadOperations();
    }
    stepper.next();
  }

  canProceedFromStep0(): boolean {
    return this.selectedErrorCode != null && this.selectedErrorCode.length > 0;
  }

  canProceedFromStep1(): boolean {
    return this.selectedOperation != null && this.selectedOperation.length > 0;
  }

  confirm() {
    if (!this.selectedErrorCode || !this.selectedOperation) {
      return;
    }
    this.submitting = true;
    const body = new FixErrorPublicationsDto(this.selectedErrorCode, this.storeCode, this.selectedOperation);
    this.publicationService.refreshPublicationErrors(body).subscribe({
      next: () => {
        this.submitting = false;
        this.snackBar.open('Fix errors request sent.', 'CLOSE', { duration: 3000 });
        this.dialogRef.close(true);
      },
      error: () => {
        this.submitting = false;
        this.snackBar.open('Failed to submit fix errors request.', 'CLOSE', { duration: 3000 });
      },
    });
  }

  close() {
    this.dialogRef.close();
  }
}
